import { Component, OnInit, ElementRef, ChangeDetectorRef, ViewChild, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Labels } from 'src/app/constants/labels';
import { isBlank, check_palindrome, isConsecutiveOK, validateWithUsername, isPresent, isData } from 'src/app/utils/utils';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { Router, RouterModule } from '@angular/router';
import { RoutePath } from 'src/app/constants/routerPath';
import { ToastrService } from 'ngx-toastr';
import { KEYS } from 'src/app/constants/keys';
import { CommonService } from 'src/app/services/common-service/common.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Observable, Subject } from 'rxjs';
import { WebcamUtil } from 'src/app/modules/webcam/util/webcam.util';
import { ReCaptcha2Component } from 'ngx-captcha';
import { AngularDeviceInformationService } from 'angular-device-information';
import { query } from '@angular/animations';
import { ActivatedRoute } from '@angular/router';
import { ConfirmModalComponent } from 'src/app/components/modal/confirm-modal/confirm-modal.component';
import { isNullOrUndefined } from 'is-what';
import { SessionTimerService } from 'src/app/services/session-timer.service';
import { map, shareReplay, tap } from 'rxjs/operators';
import { FullscreenService } from 'src/app/services/fullscreen.service';
import { LoaderService } from 'src/app/services/loader-service/loader.service';
import { CommonModule } from '@angular/common';
import { ButtonRendererComponent } from 'src/app/components/renderer/button-renderer.component';
import { AddButtonWidgetComponent } from 'src/app/components/modal/add-button-widget/add-button-widget.component';
import { WebcamInitError } from 'src/app/modules/webcam/domain/webcam-init-error';
import { NgxCaptchaModule } from 'ngx-captcha';
import { WebcamModule, WebcamImage } from 'ngx-webcam';
import { NgxLoadingModule } from 'ngx-loading-reloaded';
import { NgxMaskDirective } from 'ngx-mask';
declare var hljs: any;
enum CheckBoxType { PSW = 'PSW', FACE_ID = 'FACE_ID', NONE = 'NONE' };
@Component({
  selector: 'app-og-userlogin',
  templateUrl: './og-userlogin.component.html',
  styleUrls: ['./og-userlogin.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, NgxCaptchaModule, WebcamModule, RouterModule, NgxLoadingModule, NgxMaskDirective],
  standalone: true
})
export class OgUserloginComponent implements OnInit {

  labelName = Labels.labels;
  labelButtons = Labels.buttons;
  labelMessages = Labels.messages;
  labelForgotPassword = Labels.forgotPassword;
  bsModalRef!: BsModalRef;
  loginForm!: FormGroup;
  routePath = RoutePath;
  isForgetPassword: boolean = false;
  resetPasswordForm!: FormGroup;
  labelLogin = Labels.loginPage;
  submitted: boolean = false;
  ipAddress: any = '';
  passwordtootiptitle = Labels.loginPage.passwordtootiptitle;
  passwordtooltip = Labels.loginPage.passwordtooltip;
  passwordvalidation: boolean[] = [true, true, true, true, true];
  changePasswordForm!: FormGroup;
  selectedPattern = "^(?=.*[A-Za-z])(?=.*\\d).+$";
  ispasswordFocused = false;
  isJobSeeker = true;

  // toggle webcam on/off
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId!: string;
  public facingMode: string = 'environment';
  public errors: WebcamInitError[] = [];

  // latest snapshot
  public webcamImage: WebcamImage | null = null;
  imgCaptured = false;
  loginType = 'PSW';
  check_box_type = CheckBoxType;
  currentlyChecked!: CheckBoxType;

  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();
  compareResult: string = '';

  //public siteKey = this.commonService.getreCaptchaSiteKey();
  public siteKey!: string;
  //'6Lcp5kMcAAAAACnOfXsRMrmGva4a88tZpMLc0Exw';
  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaIsExpired = false;
  public captchaResponse?: string;
  public theme: 'light' | 'dark' = 'light';
  public size: 'compact' | 'normal' = 'normal';
  public lang = 'en';
  public type!: 'image' | 'audio';
  public useGlobalDomain: boolean = false;
  hide: boolean = true;
  public showLogo: boolean = false;
  public showLogo2: boolean = false;
  public showImg: boolean = false;

  @ViewChild('captchaElem', { static: false }) captchaElem!: ReCaptcha2Component;
  @ViewChild('langInput', { static: false }) langInput!: ElementRef;
  public loading: boolean = false;
  @ViewChild('reset', { static: false }) resetinput!: ElementRef;
  public showLogo3: boolean = false;
  public showLogoPG: boolean = false;
  messageLabel = Labels.messages;
  phoneformat!: any;
  countryCode_Fetched: any;
  maskphone = '000-000-0000';
  maskphoneIND = '0000000000';
  validaErrphone: boolean = false;
  intendedEmail = '';
  emailId:any = '';

  constructor(private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService,
    public commonService: CommonService,
    public modalRef: BsModalRef,
    private modalService: BsModalService,
    public loaderService: LoaderService,
    private cdr: ChangeDetectorRef, private http: HttpClient,
    private deviceInformationService: AngularDeviceInformationService,
    private route: ActivatedRoute, private sessionTimer: SessionTimerService,
    private fullScreenService: FullscreenService
  ) {
  }
  ngOnInit(): void {
    const jobSeeker = this.route.snapshot.queryParamMap.get('jobSeeker');
    this.emailId = this.route.snapshot.queryParamMap.get('email');
    this.isJobSeeker = jobSeeker === 'true';
    if (this.isJobSeeker && this.emailId) {
      this.openJobSeekerMailValidationPopup();
    }
    this.createLoginForm();
    this.siteKey = this.commonService.getreCaptchaSiteKey();
    this.commonService.ogLog('VERSION : JTSI_Officegaps_v1.0.16, date : 16 August 2023');
    sessionStorage.setItem('outlookSignInLoadingMsgShown', 'false');
    sessionStorage.setItem('outlookMailLoadingMsgShown', 'false');
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      });
    this.currentlyChecked = this.check_box_type.PSW;
    this.commonService.ogLog('environment : ', environment);
    sessionStorage.setItem(KEYS.user_type, 'false');
    this.getIpAddress();
    let isMobileVersion = this.commonService.mobileVersion;
    if (isMobileVersion) {
      this.loadMobileLoginPage();
    }
    switch (environment.appUrl) {
      case 'http://ogqa.gstiusa.com/':
        this.showLogo = true;
        break;
      case 'https://og2.io/':
        this.showLogo = true;
        break;
      case 'https://og.gstiusa.com/':
        this.showLogo = true;
        break;
      case 'https://ogstg.gstiusa.com/':
        this.showLogo = true;
        break;
      case 'https://ogqa.jtsusa.com/':
        this.showImg = true;
        break;
      case 'http://ogcpa.jtsusa.com/':
      case 'http://og.jtsusa.com/':
      case 'https://og.jtsusa.com/':
        this.showImg = true;
        break;
      case 'http://ogstg.jtsusa.com/':
        this.showImg = true;
        break;
      case 'https://ogstg.jtsusa.com/':
        this.showImg = true;
        break;
      case 'http://boqa.gstiusa.com/':
        this.showLogo2 = true;
        break;
      case 'https://og.jtsiindia.com/':
        this.showLogo2 = true;
        break;
      case 'http://bioogqa.jtsi.in/':
        this.showLogo3 = true;
        break;
      case 'https://ogdev.jtsusa.com/':
        this.showImg = true;
        break;
      case 'https://PGWogdev.jtsi.in/':
      case 'http://PGWogdev.jtsi.in/':
      case 'http://PGWogqa.jtsi.in/':
      case 'https://PGWogqa.jtsi.in/':
      case 'http://pgwogdev.jtsi.in/':
      case 'https://pgwogqa.jtsi.in/':
        this.showLogoPG = true;
        break;
      default:
        this.showLogo = false;
        this.showImg = false;
        this.showLogo2 = false;
        this.showLogo3 = false;
        this.showLogoPG = false;
    }
    this.changePasswordForm = this.formBuilder.group({
      newpassword: ['', [Validators.required, Validators.minLength(8), Validators.pattern(this.selectedPattern)]]
    }, {
      validator: [
        check_palindrome('newpassword'),
        isConsecutiveOK('newpassword'),
        validateWithUsername('newpassword', this.loginForm.value.email)
      ]
    });
  } 
  openJobSeekerMailValidationPopup() {
    this.modalRef = this.modalService.show(ConfirmModalComponent, {
      animated: true, class: KEYS.confirmModal
    });
    this.modalRef.content.data = {
      title: 'Validate',
      message: this.messageLabel.intended_email_confirm_msg.message,
      email: this.emailId,
      btnConfirm: 'Validate',
      btnConfirmStyle: 'btn-red'
    }
    this.modalRef.content.buttonevent.subscribe((res: string) => {
      if (res) {
        this.confirmJobSeekerUser(res);
      }
    });
  }
  confirmJobSeekerUser(emailRes: string) {
    const email = emailRes?.trim().toLowerCase();
    if (!email)
      return;
    this.commonService.ogLog('emailRes x', emailRes);
    this.authService.checkIfJobSeekerAccount(email).subscribe({
    next: (res: any) => {
      const exists = res?.table?.[0]?.user_exists;
      this.modalRef.hide();
      if (exists) {
        this.isJobSeeker = false;
         this.router.navigate(
          ['/userlogin']
        );
        this.loginForm = this.formBuilder.group({
          email: ['', Validators.required],
          password: ['', Validators.required],
          recaptcha: ['', environment.googleCaptcha ? Validators.required : null]
        });
      } else {
        this.isJobSeeker = true;
        this.router.navigate(
          ['/userlogin'],
          {
            queryParams: {
              JobSeeker: true,
              email: email
            }
          }
        );
        this.loginForm = this.formBuilder.group({
          firstName: ['', Validators.required],
          lastName: ['', Validators.required],
          contact: ['', Validators.required],
          email: ['', Validators.required],
          password: ['', Validators.required],
        });
      }
      this.loginForm.patchValue({
        email: email
      });
    },
    error: (err: any) => {
      console.log('JobSeeker account check failed', err);
    }
    });
  }
  async getCountrycodeofPhone() {
    const customerid = this.commonService.getUserCredentials(KEYS.credential_customer_id);
    this.commonService.getCountryForPhone(customerid).subscribe((data: any) => {
      if (isData(data)) {
        this.countryCode_Fetched = data['table'][0].gstibo_phone_country;
        if (this.countryCode_Fetched == 'us') {
          this.phoneformat = 2;
        }
        else if (this.countryCode_Fetched == 'india') {
          this.phoneformat = 1;
        }
        else {
          this.phoneformat = 1;
        }
      }
    });
  } 
  validatephone(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inpuchar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inpuchar)) {
      event.preventDefault();
    }
  }
  validatephonenum(event: any) {
    let inpuchar = String.fromCharCode(event.charCode);
    inpuchar = this.loginForm.value.contact;
    const customerid = this.commonService.getUserCredentials(KEYS.credential_customer_id);
    this.commonService.getCountryForPhone(customerid).subscribe((data: any): any => {
      if (isData(data)) {
        const countryCode = data['table'][0].gstibo_phone_country;
        let cleaned = inpuchar;
        if (countryCode == 'us') {
          let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

          if (match) {
            this.validaErrphone = false;
            return true;
          }
          else {
            this.commonService.showModalValidate(this.messageLabel.invalid_phone_msg.message + " on contact ",'',this.labelMessages.static_messages.error,
            this.messageLabel.invalid_phone_msg.message + " on contact "            );
            this.validaErrphone = true;
            return false;
          }
        }
        else if (countryCode == 'india') {

          let match = cleaned.match(/^(\d{10})$/);
          if (match) {
            this.validaErrphone = false;
            return true;
          }
          else {
            this.commonService.showModalValidate(this.messageLabel.invalid_phone_msg.message + " on contact",'',this.labelMessages.static_messages.error,this.messageLabel.invalid_phone_msg.message + " on contact ");
            this.validaErrphone = true;
            return false;
          }

        }
        else if (countryCode == 'uk') {
          let match = cleaned.match(/^(\d{4})(\d{6})$/);
          if (match) {
            this.validaErrphone = false;
            return true;
          }
          else {
            this.commonService.showModalValidate(this.messageLabel.invalid_phone_msg.message + " on contact",'',
              this.labelMessages.static_messages.error,this.messageLabel.invalid_phone_msg.message + " on contact ");
            this.validaErrphone = true;
            return false;
          }
        }
        else if (cleaned.length == 10) {
          let match = cleaned.match(/^(\d{10})$/);
          if (match) {
            this.validaErrphone = false;
            return true;
          }
          else {
            this.commonService.showModalValidate(this.messageLabel.invalid_phone_msg.message + " on contact",'',
              this.labelMessages.static_messages.error,this.messageLabel.invalid_phone_msg.message + " on contact ");
            this.validaErrphone = true;
            return false;
          }
        }
        else {
          if (cleaned.length > 10 || cleaned.length < 10) {
            this.commonService.showModalValidate(this.messageLabel.invalid_phone_msg.message + " on contact",'',
              this.labelMessages.static_messages.error,this.messageLabel.invalid_phone_msg.message + " on contact ");
            this.validaErrphone = true;
            return false;
          }
        }

      }
    });
  }
  sendDailyReqMail() {
    this.authService.sendDailyReqMail().subscribe({
      next: (res: any) => {
        this.commonService.ogLog(`res?.table[0] updateJrApplyStatus x`, res?.table[0]);
      },
      error: (error: any) => {
        console.log('Apply status save error:', error);
      }
    });
  }
  ValidatePassword(event: any) {
    let password: any = event.target.value;
    const control = this.changePasswordForm.controls['newpassword'];
    control.setValue(password)
    const errors = control.errors || {}

    this.passwordvalidation[0] = !errors['minlength'];
    this.passwordvalidation[1] = !errors['pattern'];
    this.passwordvalidation[2] = !errors['palindrome'];
    this.passwordvalidation[3] = !errors['isConsecutiveOK'];
    this.passwordvalidation[4] = !errors['containsUserName'];
  }
  loadMobileLoginPage() {
    /*Device Information Starts */
    const displayDeviceInfo = this.deviceInformationService.getDeviceInfo();
    const isMobile = this.deviceInformationService.isMobile();
    const isTablet = this.deviceInformationService.isTablet();
    const isDesktop = this.deviceInformationService.isDesktop();
    this.commonService.ogLog('displayDeviceInfo:', displayDeviceInfo);
    this.commonService.ogLog('isMobile:', isMobile);
    this.commonService.ogLog('isTablet:', isTablet);
    this.commonService.ogLog('isDesktop:', isDesktop);
    if (isMobile || isTablet) {
      this.commonService.ogLog('mobile login');
      window.location.href = this.commonService.mobileUrl;
    }
  }

  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    if (error.mediaStreamError && error.mediaStreamError.name === 'NotAllowedError') {
      console.warn('Camera access was not allowed by user!');
    }
    this.errors.push(error);
  }


  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
  }


  public handleImage(webcamImage: WebcamImage): void {
    this.commonService.ogLog('errors image', this.errors);
    this.commonService.ogLog('received webcam image', webcamImage);
    this.webcamImage = webcamImage;
    this.imgCaptured = true;
  }


  public cameraWasSwitched(deviceId: string): void {
    this.commonService.ogLog('active device: ' + deviceId);
    this.deviceId = deviceId;
  }


  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }


  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }


  public get videoOptions(): MediaTrackConstraints {
    const result: MediaTrackConstraints = {};
    if (this.facingMode && this.facingMode !== '') {
      result.facingMode = { ideal: this.facingMode };
    }
    return result;
  }
  clearImage() {
    this.webcamImage = null;
    this.imgCaptured = false;
  }
  /* uploadImage() {
     console.log('uploadImage', this.webcamImage);
     if (isPresent(this.webcamImage)) {
       let dataurl = this.webcamImage.imageAsDataUrl;
       let filename = 'haha.png';
       let format = 'png';
       this.dataURLtoFile(dataurl, filename, format);
     }
     else {
       this.toastr.error('Please capture image.');
     }
   }
   dataURLtoFile(dataurl, filename, format) {
     let inputLabel = '', filenames = '';
     const arr = dataurl.split(',');
     const mime = arr[0].match(/:(.*?);/)[1];
     const bstr = atob(arr[1]);
     let n = bstr.length;
     const u8arr = new Uint8Array(n);
     while (n--) {
       u8arr[n] = bstr.charCodeAt(n);
     }
 
     const curTime = (new Date().toLocaleDateString().replace("/", "")).replace("/", "") + new Date().getTime();
     const fname = 'haha';
     const extension = format;
     //fname.slice((Math.max(0, fname.lastIndexOf(".")) || Infinity) + 1);
     const filesaved = curTime + '.' + extension;
     let userID = '1';
     let fullpath = "uploadFiles/gstiusa/" + userID + "/" + filesaved;
     // fullpath = (((fullpath.replace("/", "~")).replace("/", "~")).replace("/", "~")).replace("/", "~");
     // userData.imgUrl = fullpath;
     // console.log('errorstart',userData.imgFiles, curTime, userID)
 
     let files = new File([u8arr], filesaved, { type: format });
     // saveAs(new File([u8arr], filename, {type: format}));
     this.commonService.uploadManageUserProfile(files, curTime, userID).subscribe(data => {
 
       console.log('uploadManageUserProfile : ', data);
       this.commonService.saveUploadFiles(this.forms.value.inputId, this.forms.value.recordId, this.commonService.getUserCredentials(KEYS.credential_account_id),
         this.forms.value.pageId, fullpath, 'IMG_' + filesaved,
         this.commonService.getUserCredentials(KEYS.credential_account_id)).subscribe(data => {
           if (data['table']) {
             this.showFileContentToControl(fullpath);
             let filecount = data['table'].map(x => x.filecount);
             filenames += 'IMG_' + filesaved;
             this.filecount = filecount;
             // if (i == this.selectedFiles.length - 1) {
             // let lastChar = filenames.slice(-1);
             // if (lastChar == ',') {
             //   filenames = filenames.slice(0, -1);
             // }
             inputLabel += "File Name " + " ~~ " + filenames + "~~~";
             let ipaddress = '', machinename = '';
             this.commonService.saveAuditTrial(this.forms.value.pageId, KEYS.saveType.INSERT, ipaddress, machinename, this.commonService.getUserCredentials(KEYS.credential_account_id),
               inputLabel, this.forms.value.recordId).subscribe(data => {
               }, error => {
                 console.log('generateAuditTrail Error:', error);
               });
             // }
             this.toastr.success('File uploaded successfully.');
           }
         }, error => {
           console.log('fileupload insertQuery Error:', error);
         });
     }, error => {
       console.log('Error!', error);
     });
 
   }
   */
  compareImage1() {
    this.commonService.ogLog('this.loginForm : ', this.loginForm.value);
    if (this.loginType == 'FACE_ID') {
      this.triggerSnapshot();
      this.commonService.ogLog('uploadImage', this.webcamImage);
      if (isPresent(this.webcamImage)) {
        let dataurl = this.webcamImage!.imageAsDataUrl;

        const email = this.loginForm.value.email;
        this.compareResult = '';
        this.compareFaces_without_username(dataurl);
      }
      else {
        this.commonService.showModalValidate('Please capture image.', '', this.messageLabel.static_messages.error, 'Please capture error.');
      }
    }
  }
  compareImage() {
    this.commonService.ogLog('this.loginForm : ', this.loginForm.value);
    if (this.loginType == 'FACE_ID') {
      this.triggerSnapshot();
      this.commonService.ogLog('uploadImage', this.webcamImage);
      if (isPresent(this.webcamImage)) {
        let dataurl = this.webcamImage!.imageAsDataUrl;
        this.compareResult = '';
        this.compareFaces_without_username(dataurl);
      }
      else {
        this.commonService.showModalValidate('Please capture image.', '', this.messageLabel.static_messages.error, 'Please capture error.');
      }
    }
  }
  private makeblob(dataURL: any) {
    const BASE64_MARKER = ';base64,';
    const parts = dataURL.split(BASE64_MARKER);
    const contentType = parts[0].split(':')[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: contentType });
  }
  compareFaces(dataurl: any, face_url2: any, data: any) {
    const imgURL1 = '';
    const imgURL2 = '';
    const blob1 = this.makeblob(dataurl);
    this.commonService.faceRecognition_detect(blob1).subscribe(
      (detect1) => {
        this.commonService.ogLog("faceRecognition_detect1", detect1);
        if (detect1.length > 0) {
          const faceId1 = detect1[0].faceId;

          this.commonService.faceRecognition_detect_withUrl(face_url2).subscribe(
            (detect2) => {
              this.commonService.ogLog("faceRecognition_detect2", detect2);
              const faceId2 = detect2[0].faceId;

              this.commonService.faceRecognition_verify(faceId1, faceId2).subscribe(
                (matchdetails) => {
                  this.commonService.ogLog("faceRecognition_verify", matchdetails);
                  this.compareResult = (matchdetails.isIdentical == true ? 'Success.' : 'Fail.');
                  if (matchdetails.isIdentical == true) {
                    /** navigate on success  */
                    if (isData(data)) {
                      this.authService.updateUserInfo(data['table'][0], false);
                      // try { this.authService.updateTokenDetails(data['tokenTable'] !== undefined ? data['tokenTable'][0] : null); } catch { }
                      this.commonService.loadNotificationData();
                      // this.router.navigate([this.routePath.home]);
                      this.router.navigate([this.routePath.dashboardUser]);
                    } else {
                      this.commonService.ogLog('Login failed');
                      //this.toastr.error(this.labelMessages.login_failed.message, this.labelMessages.login_failed.title);
                      this.commonService.showModalValidate(this.labelMessages.login_failed.message, '', this.messageLabel.static_messages.error, this.labelMessages.login_failed.title);
                    }
                    /** navigate on success end */
                  }
                  else {
                    this.commonService.ogLog('Face ID Login failed');
                    // this.toastr.error(this.labelMessages.login_failed.message, this.labelMessages.login_failed.title);
                    this.commonService.showModalValidate(this.labelMessages.login_failed.message, '', this.messageLabel.static_messages.error, this.labelMessages.login_failed.title);
                  }
                },
                (error) => {
                  console.log("faceRecognition_verify error", error.error);
                });

            },
            (error) => {
              console.log("faceRecognition_detect error", error.error);
            });
        }
        else {
          // this.toastr.warning('No face detected.');
          this.commonService.showModalValidate('No face detected.', '', this.messageLabel.static_messages.error, 'No face detected.');
        }
      },
      (error) => {
        console.log("faceRecognition_detect error", error.error);
      });

  }
  compareFaces_without_username(dataurl: any) {
    const imgURL1 = '';
    const imgURL2 = '';
    const blob1 = this.makeblob(dataurl);
    this.commonService.faceRecognition_detect(blob1).subscribe(
      (detect1) => {
        this.commonService.ogLog("faceRecognition_detect1", detect1);
        if (detect1.length > 0) {
          const faceId = detect1[0].faceId;
          this.commonService.faceList_find_similar(faceId).subscribe(
            (matchdetails) => {
              this.commonService.ogLog("faceRecognition_verify", matchdetails);
              if (matchdetails.length > 0) {
                this.commonService.faceList_get_face_lists().subscribe(data => {
                  this.commonService.ogLog("addFaceToFacelist ", data)
                  const allFaceList = data.persistedFaces;
                  // let faceList = allFaceList.filter(id => id.userData == matchdetails[0].persistedFaceId);
                  let faceList = allFaceList.filter((id: any) => id.persistedFaceId == matchdetails[0].persistedFaceId);
                  this.commonService.ogLog("faceList after filter", faceList)
                  this.authService.signInAuthenticate(faceList[0].userData, 'psw', false, true, this.ipAddress).subscribe((data: any) => {
                    this.commonService.ogLog('data after sign in : ', data);
                    if (data['table'] && data['table'].length > 0) {
                      // const dataRow = data['table'][0];
                      /** navigate on success  */
                      if (isPresent(data) && isPresent(data['table']) && isPresent(data['table'][0])) {
                        ///old code
                        /* 
                        this.authService.updateUserInfo(data['table'][0], false);
                        try { this.authService.updateTokenDetails(data['tokenTable'] !== undefined ? data['tokenTable'][0] : null); } catch { }
                        this.commonService.loadNotificationData();
                        // this.router.navigate([this.routePath.home]);
                        this.router.navigate([this.routePath.dashboardUser]);
                        */
                        this.commonService.setCustomerEmpDashboardProjectId(isPresent(data['table'][0].gstibo_default_project) ? data['table'][0].gstibo_default_project : null);
                        this.authService.updateUserInfo(data['table'][0], false);
                        try { this.authService.updateTokenDetails(data['tokenTable'] !== undefined ? data['tokenTable'][0] : null); } catch { }
                        this.selectCountryForPhone(data['table'][0]);
                        this.selectcustomer_logo(data['table'][0].gstibo_logo_images_path);
                        this.commonService.loadNotificationData();
                        sessionStorage.removeItem(KEYS.customerDateFormat);
                        if (isPresent(data['table'][0].gstibo_date_format)) {
                          sessionStorage.setItem(KEYS.customerDateFormat, data['table'][0].gstibo_date_format.toString());
                        }
                        if (isPresent(data['table'][0].gstibo_lock_till_date)) {
                          sessionStorage.setItem(KEYS.lockTillDate, data['table'][0].gstibo_lock_till_date.toString());
                        }
                        sessionStorage.removeItem(KEYS.need_max_hours_check);
                        sessionStorage.setItem(KEYS.need_max_hours_check, data['table'][0].gstibo_need_maxhours_check);
                        this.commonService.setDashbord(true);
                        this.setControlRights();
                        this.setControlRightsSourcing();
                        this.setControlRightsHRReview();
                        this.setControlRightsManagementApproval();
                        //this.loader.setLoaderStatic();
                        // this.router.navigate([this.routePath.home]);              
                        const userdetails = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
                        if (this.commonService.getUserCredentials(KEYS.credential_site_value).toLowerCase() == 'jusa' && userdetails.user_Type_Name.toLowerCase() == 'vendor') {
                          this.commonService.getMasterData(this.commonService.getUserCredentials(KEYS.credential_account_id), 1, 1).subscribe((data: any) => {
                            let menudata;
                            if (isPresent(data['menu']) && isPresent((data['menu'])['table'])) {
                              menudata = (data['menu'])['table'];
                              this.commonService.ogLog('menudata', menudata);

                              sessionStorage.setItem(KEYS.userMenuList, JSON.stringify(menudata));
                              const mainPageDetail = {
                                isAddMode: false,
                                menuId: 321,
                                pageId: 408,// 505,
                                pageName: "Contact Details",
                                parentMenuId: 320,
                                withChildInnerPage: 0,
                                withChildMenues: 0
                              }
                              sessionStorage.setItem(KEYS.mainPageDetails, JSON.stringify(mainPageDetail));
                              const pageDetails = {
                                pageId: 408,
                                pageName: 'Contact Details',
                                parentMenuId: 320,
                                pagePrimaryKey: userdetails.gstibo_vendor_id,// 144,// data['table'][0].tbl_gstibo_vendor_management_details_id,
                                pagePrimaryKeyColumnName: 'tbl_gstibo_contact_hdr_id',
                                gridTableName: 'tbl_gstibo_contact_hdr',
                                gridId: 342,
                                gridNavigationType: 1,
                                isAddMode: false,
                                isInnerGrid: '0',
                                parentPageId: 409,
                              }
                              this.commonService.ogLog('pagedata:', pageDetails);
                              sessionStorage.setItem("acivemenuId", pageDetails.parentMenuId.toString());
                              this.commonService.setParentMenuName('Contacts');
                              sessionStorage.setItem('moduleName', 'Contacts');
                              sessionStorage.setItem(KEYS.subPageDetails, JSON.stringify(pageDetails));
                              this.commonService.setParentTblData$(
                                {
                                  pagePrimaryKey: userdetails.gstibo_vendor_id,//data['table'][0].tbl_gstibo_vendor_management_details_id,
                                  pagePrimaryKeyColumnName: 'tbl_gstibo_contact_hdr_id'
                                });
                              this.commonService.setDynamicPageDataForEdit(pageDetails);
                              sessionStorage.removeItem(KEYS.vendor_data);
                              const path = RoutePath.userSubPageLayout.replace(':page_name', pageDetails.pageName);// JSON.parse(sessionStorage.getItem(KEYS.mainPageDetails)).pageName);
                              // this.router.navigate([path, pageDetails.pageName]);
                            }
                          });
                          this.router.navigate([this.routePath.dashboardUser], { queryParams: { menuid: environment.vendordashboardId } });
                          this.loading = false;
                        }
                        else {
                          if (data['table'][0].gstibo_dashboard_id == null || data['table'][0].gstibo_dashboard_id == '') {
                            const dashboardId = (Number(environment.dashboardId) == 181 || Number(environment.dashboardId) == 303 || Number(environment.dashboardId) == 320) ? 0 : environment.dashboardId;
                            this.router.navigate([this.routePath.dashboardUser], { queryParams: { menuid: dashboardId } });
                            this.loading = false;
                          }
                          else {
                            const dashboardId = (Number(data['table'][0].gstibo_dashboard_id) == 181 || Number(data['table'][0].gstibo_dashboard_id) == 303 || Number(data['table'][0].gstibo_dashboard_id) == 320) ? 0 : data['table'][0].gstibo_dashboard_id;
                            this.router.navigate([this.routePath.dashboardUser], { queryParams: { menuid: dashboardId } });
                            this.loading = false;
                          }
                        }
                      } else {
                        this.commonService.ogLog('Login failed');
                        //this.toastr.error(this.labelMessages.login_failed.message, this.labelMessages.login_failed.title);
                        this.commonService.showModalValidate(this.labelMessages.login_failed.message, '', this.messageLabel.static_messages.error, this.labelMessages.login_failed.title);
                      }
                      /** navigate on success end */
                    }
                    else {
                      this.commonService.ogLog('Login failed');
                      // this.toastr.error(this.labelMessages.login_failed.message, this.labelMessages.login_failed.title);
                      this.commonService.showModalValidate(this.labelMessages.login_failed.message, '', this.messageLabel.static_messages.error, this.labelMessages.login_failed.title);
                    }
                  }, error => {
                    console.log('signInAuthenticate insertQuery Error:', error);
                    this.compareResult = 'Server Error.';
                  });
                });
              }
              else {
                console.log('Face ID Login failed');
                //this.toastr.error(this.labelMessages.login_failed.message, this.labelMessages.login_failed.title);
                this.commonService.showModalValidate(this.labelMessages.login_failed.message, '', this.messageLabel.static_messages.error, this.labelMessages.login_failed.title);
              }
            },
            (error) => {
              console.log("faceRecognition_verify error", error.error);
            });
        }
        else {
          // this.toastr.warning('No face detected.');
          this.commonService.showModalValidate('No face detected.', '', this.messageLabel.static_messages.error, 'No face detected.');
        }
      },
      (error) => {
        console.log("faceRecognition_detect error", error.error);
      });

  }
  compareFaces_without_username1(dataurl: any) {
    const imgURL1 = '';
    const imgURL2 = '';
    const blob1 = this.makeblob(dataurl);
    this.commonService.faceRecognition_detect(blob1).subscribe(
      (detect1) => {
        this.commonService.ogLog("faceRecognition_detect1", detect1);
        if (detect1.length > 0) {
          const faceId = detect1[0].faceId;

          // this.commonService.faceRecognition_detect_withUrl(face_url2).subscribe(
          //   (detect2) => {
          //     this.commonService.ogLog("faceRecognition_detect2", detect2);
          //     const faceId2 = detect2[0].faceId;

          this.commonService.faceList_find_similar(faceId).subscribe(
            (matchdetails) => {
              this.commonService.ogLog("faceRecognition_verify", matchdetails);
              // this.compareResult = (matchdetails.isIdentical == true ? 'Success.' : 'Fail.');



              if (matchdetails.length > 0) {
                this.commonService.faceList_get_face_lists().subscribe(data => {
                  this.commonService.ogLog("addFaceToFacelist ", data)
                  const allFaceList = data.persistedFaces;
                  // let faceList = allFaceList.filter(id => id.userData == matchdetails[0].persistedFaceId);
                  let faceList = allFaceList.filter((id: any) => id.persistedFaceId == matchdetails[0].persistedFaceId);
                  this.commonService.ogLog("faceList after filter", faceList)
                  this.authService.signInAuthenticate(faceList[0].userData, 'psw', false, true, this.ipAddress).subscribe((data: any) => {
                    this.commonService.ogLog('data after sign in : ', data);
                    if (data['table'] && data['table'].length > 0) {
                      // const dataRow = data['table'][0];
                      /** navigate on success  */
                      if (isData(data)) {
                        this.authService.updateUserInfo(data['table'][0], false);
                        // try { this.authService.updateTokenDetails(data['tokenTable'] !== undefined ? data['tokenTable'][0] : null); } catch { }
                        this.commonService.loadNotificationData();
                        // this.router.navigate([this.routePath.home]);
                        this.router.navigate([this.routePath.dashboardUser]);
                      } else {
                        this.commonService.ogLog('Login failed');
                        // this.toastr.error(this.labelMessages.login_failed.message, this.labelMessages.login_failed.title);
                        this.commonService.showModalValidate(this.labelMessages.login_failed.message, '', this.messageLabel.static_messages.error, this.labelMessages.login_failed.title);
                      }

                      /** navigate on success end */
                    }
                    else {
                      this.commonService.ogLog('Login failed');
                      // this.toastr.error(this.labelMessages.login_failed.message, this.labelMessages.login_failed.title);
                      this.commonService.showModalValidate(this.labelMessages.login_failed.message, '', this.messageLabel.static_messages.error, this.labelMessages.login_failed.title);
                    }
                  }, error => {
                    console.log('signIn insertQuery Error:', error);
                    this.compareResult = 'Server Error.';
                  });
                });


              }
              else {
                this.commonService.ogLog('Face ID Login failed');
                // this.toastr.error(this.labelMessages.login_failed.message, this.labelMessages.login_failed.title);
                this.commonService.showModalValidate(this.labelMessages.login_failed.message, '', this.messageLabel.static_messages.error, this.labelMessages.login_failed.title);
              }




            },
            (error) => {
              console.log("faceRecognition_verify error", error.error);
            });

          // },
          // (error) => {
          //   console.log("faceRecognition_detect error", error.error);
          // });
        }
        else {
          //this.toastr.warning('No face detected.');
          this.commonService.showModalValidate('No face detected.', '', this.messageLabel.static_messages.error, 'No face detected.');
        }
      },
      (error) => {
        console.log("faceRecognition_detect error", error.error);
      });

  }
  //Face ID login end

  //Captcha Start

  ngAfterViewInit(): void {
    this.highlight();
  }

  handleReset(): void {
    this.captchaSuccess = false;
    this.captchaResponse = undefined;
    this.captchaIsExpired = false;
    this.cdr.detectChanges();
  }

  handleSuccess(captchaResponse: string): void {
    this.captchaSuccess = true;
    this.captchaResponse = captchaResponse;
    this.captchaIsExpired = false;
    this.cdr.detectChanges();
  }

  handleLoad(): void {
    this.captchaIsLoaded = true;
    this.captchaIsExpired = false;
    this.cdr.detectChanges();
  }
  handleError(): void {
    // this.captchaIsLoaded = true;
    // this.captchaIsExpired = false;
    // this.cdr.detectChanges();
  }

  handleExpire(): void {
    this.captchaSuccess = false;
    this.captchaIsExpired = true;
    this.cdr.detectChanges();
  }

  changeTheme(theme: 'light' | 'dark'): void {
    this.theme = theme;
  }

  changeSize(size: 'normal' | 'compact'): void {
    this.size = size;
  }

  changeType(type: 'image' | 'audio'): void {
    this.type = type;
  }

  setLanguage(): void {
    this.lang = this.langInput.nativeElement.value;
  }

  setUseGlobalDomain(use: boolean): void {
    this.useGlobalDomain = use;
  }

  getCurrentResponse(): void {
    const currentResponse = this.captchaElem.getCurrentResponse();
    if (!currentResponse) {
      alert('There is no current response - have you submitted captcha?');
    } else {
      alert(currentResponse);
    }
  }

  getResponse(): void {
    const response = this.captchaElem.getResponse();
    if (!response) {
      alert('There is no response - have you submitted captcha?');
    } else {
      alert(response);
    }
  }

  reload(): void {
    this.captchaElem.reloadCaptcha();
  }

  getCaptchaId(): void {
    alert(this.captchaElem.getCaptchaId());
  }

  reset(): void {
    this.captchaElem.resetCaptcha();
  }

  private highlight(): void {
    const highlightBlocks = document.getElementsByTagName('code');
    for (let i = 0; i < highlightBlocks.length; i++) {
      const block = highlightBlocks[i];
      hljs.highlightBlock(block);
    }
  }
  //Captcha End


  getSiteKey() {
    this.commonService.getSettingTblData().subscribe((data: any) => {
      this.commonService.ogLog('data : ', data);
      if (data['table'] && data['table'].length > 0) {
        const dataRow = data['table'][0];
        this.siteKey = (isPresent(dataRow.gstibo_captcha_sitekey) ? dataRow.gstibo_captcha_sitekey : '');
      }
      else {
        this.commonService.ogLog('getSiteKey failed');
        // this.toastr.error('reCAPTCHA loading issue found.');
        this.commonService.showModalValidate('reCAPTCHA loading issue found.', '', this.messageLabel.static_messages.error, 'reCAPTCHA loading issue found.');
      }
    }, error => {
      console.log('reCAPTCHA Error:', error);
    });
  }

  createLoginForm() {
    if (this.isJobSeeker) {
      this.loginForm = this.formBuilder.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        contact: ['', Validators.required],
        email: ['', Validators.required],
        password: ['', Validators.required],
      });
    } else {
      this.loginForm = this.formBuilder.group({
        email: ['', Validators.required],
        password: ['', Validators.required],
        recaptcha: ['', environment.googleCaptcha ? Validators.required : null]
      });
    }
    this.resetPasswordForm = this.formBuilder.group({
      username: ['', Validators.required]
    });
    let username: any = null;
    let password: any = null;
    let sitekey: any = null;
    this.route.queryParams.subscribe(params => {
      username = params['username'];
      password = params['password'];
      sitekey = params['sitekey'];
    });

    if (username != null && password != null) {
      if (sitekey == this.siteKey) {
        this.commonService.ogLog('username:', username, '| password:', password);
        this.loginForm.patchValue({ email: username, password: password, recaptcha: 'webcall' });
        this.commonService.ogLog('this.loginForm:', this.loginForm);
        this.onSubmit();
      } else {
        this.commonService.showModalValidate('Please contact administrator Inavalid site key', '', this.messageLabel.static_messages.error, 'Please contact administrator Inavalid site key');
      }
    }
  }
  onSubmitRegisterForm() {
    this.commonService.ogLog('this.loginForm X : ', this.loginForm.value);
     this.authService.registerNewUser(this.loginForm.value?.firstName,
      this.loginForm.value?.lastName,
      this.loginForm.value?.contact,
      this.loginForm.value?.email,
      this.loginForm.value?.password
    ).subscribe({
        next: (result: any) => {
          if (result) {
            this.commonService.ogLog('result x', result);
            this.onSubmit();
          }
        },
        error: (err) => {
          console.error("Error ",err);
        }
      });
  }
  onSubmit() {
    this.commonService.ogLog('this.loginForm : ', this.loginForm.value);
    if (this.loginType == 'FACE_ID') {
    }
    else {
      if (this.loginForm.valid) {
        this.loading = true;
        this.commonService.ogLog('Login Form validated : ', this.loginForm.value);
        this.authService.signInAuthenticate(this.loginForm.value.email, this.loginForm.value.password, false, false, this.ipAddress).subscribe((data: any) => {
          this.commonService.ogLog('data : ', data);
          if (isData(data)) {

            if (!isPresent(data['table'][0]['result'])) {
              this.commonService.setCustomerEmpDashboardProjectId(isPresent(data['table'][0].gstibo_default_project) ? data['table'][0].gstibo_default_project : null);
              this.authService.updateUserInfo(data['table'][0], false);
              try { this.authService.updateTokenDetails(data['tokenTable'] !== undefined ? data['tokenTable'][0] : null); } catch { }
              this.selectCountryForPhone(data['table'][0]);
              this.selectcustomer_logo(data['table'][0].gstibo_logo_images_path);
              this.commonService.loadNotificationData();
              this.runDailyManageUserContactSync();
              sessionStorage.removeItem(KEYS.customerDateFormat);
              if (isPresent(data['table'][0].gstibo_date_format)) {
                sessionStorage.setItem(KEYS.customerDateFormat, data['table'][0].gstibo_date_format.toString());
              }
              if (isPresent(data['table'][0].gstibo_lock_till_date)) {
                sessionStorage.setItem(KEYS.lockTillDate, data['table'][0].gstibo_lock_till_date.toString());
              }
              if (isPresent(data['table'][0].gstibo_file_upload_path)) {
                this.commonService.setFileUploadPath(data['table'][0].gstibo_file_upload_path.toString());
              }
              sessionStorage.removeItem(KEYS.need_max_hours_check);
              sessionStorage.setItem(KEYS.need_max_hours_check, data['table'][0].gstibo_need_maxhours_check);
              if (isPresent(data['table'][0].gstibo_manage_approval_controlId)) {
                sessionStorage.setItem(KEYS.mamangementcontrolid, data['table'][0].gstibo_manage_approval_controlId);
              }

              this.loadLanguageText(data['table1']);
              this.commonService.setDashbord(true);
              this.setControlRights();
              this.setControlRightsSourcing();
              this.setControlRightsHRReview();
              this.setControlRightsManagementApproval();
              this.setMultiCatgoryvalue();
              //this.loader.setLoaderStatic();
              // this.router.navigate([this.routePath.home]);  
              this.commonService.addLoginSession(data['table'][0].gstibo_account_id).subscribe((dataSession: any) => {
                sessionStorage.setItem(KEYS.ipAddress, this.ipAddress)
                console.log('login', dataSession['table'][0].login_session_history_id)
                sessionStorage.setItem(KEYS.loginHistoryId, dataSession['table'][0].login_session_history_id);
                this.sessionTimer.startTimer();
              })
              const userdetails = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
              if (this.commonService.getUserCredentials(KEYS.credential_site_value).toLowerCase() == 'jusa') {
                if (userdetails.user_Type_Name.toLowerCase() == 'vendor') {
                  this.commonService.getMasterData(this.commonService.getUserCredentials(KEYS.credential_account_id), 1, 1).subscribe((data: any) => {
                    let menudata;
                    if (isPresent(data['menu']) && isPresent((data['menu'])['table'])) {
                      menudata = (data['menu'])['table'];
                      this.commonService.ogLog('menudata', menudata);

                      sessionStorage.setItem(KEYS.userMenuList, JSON.stringify(menudata));
                      const mainPageDetail = {
                        isAddMode: false,
                        menuId: 321,
                        pageId: 408,// 505,
                        pageName: "Contact Details",
                        parentMenuId: 320,
                        withChildInnerPage: 0,
                        withChildMenues: 0
                      }
                      sessionStorage.setItem(KEYS.mainPageDetails, JSON.stringify(mainPageDetail));
                      const pageDetails = {
                        pageId: 408,
                        pageName: 'Contact Details',
                        parentMenuId: 320,
                        pagePrimaryKey: userdetails.gstibo_vendor_id,// 144,// data['table'][0].tbl_gstibo_vendor_management_details_id,
                        pagePrimaryKeyColumnName: 'tbl_gstibo_contact_hdr_id',
                        gridTableName: 'tbl_gstibo_contact_hdr',
                        gridId: 342,
                        gridNavigationType: 1,
                        isAddMode: false,
                        isInnerGrid: '0',
                        parentPageId: 409,
                      }
                      this.commonService.ogLog('pagedata:', pageDetails);
                      sessionStorage.setItem("acivemenuId", pageDetails.parentMenuId.toString());
                      this.commonService.setParentMenuName('Contacts');
                      sessionStorage.setItem('moduleName', 'Contacts');
                      sessionStorage.setItem(KEYS.subPageDetails, JSON.stringify(pageDetails));
                      this.commonService.setParentTblData$(
                        {
                          pagePrimaryKey: userdetails.gstibo_vendor_id,//data['table'][0].tbl_gstibo_vendor_management_details_id,
                          pagePrimaryKeyColumnName: 'tbl_gstibo_contact_hdr_id'
                        });
                      this.commonService.setDynamicPageDataForEdit(pageDetails);
                      sessionStorage.removeItem(KEYS.vendor_data);
                      const path = RoutePath.userSubPageLayout.replace(':page_name', pageDetails.pageName);// JSON.parse(sessionStorage.getItem(KEYS.mainPageDetails)).pageName);
                      // this.router.navigate([path, pageDetails.pageName]);
                    }
                  });
                  this.router.navigate([this.routePath.dashboardUser], { queryParams: { menuid: environment.vendordashboardId } });
                  this.loading = false;
                } else {
                  this.navigateUserToDefaultList();
                }
              }
              else {
                if (data['table'][0].gstibo_dashboard_id == null || data['table'][0].gstibo_dashboard_id == '') {
                  this.router.navigate([this.routePath.dashboardUser], { queryParams: { menuid: environment.dashboardId } });
                  this.loading = false;
                }
                else {
                  const dashboardId = (Number(data['table'][0].gstibo_dashboard_id) == 181 || Number(data['table'][0].gstibo_dashboard_id) == 303 || Number(data['table'][0].gstibo_dashboard_id) == 320) ? 0 : data['table'][0].gstibo_dashboard_id;
                  this.router.navigate([this.routePath.dashboardUser], { queryParams: { menuid: dashboardId } });
                  this.loading = false;
                }
              }
            }
            else {
              if (data['table'][0]['result'] == 'notreset') {
                this.cdr.markForCheck();
                this.loading = false;
                const config: ModalOptions = { class: KEYS.modalConfigClassMD, backdrop: "static" }
                this.bsModalRef = this.modalService.show(ConfirmModalComponent, config)

                this.bsModalRef.content.data = {
                  title: 'Confirm',
                  message: this.labelMessages.reset_confirm_msg.message,
                  btnConfirm: 'Yes',
                  btnCancel: 'No',
                  btnConfirmStyle: 'btn-red',
                  btnCancelStyle: 'btn-green'
                }

                this.bsModalRef.content.buttonevent.subscribe((res: any) => {
                  if (res) {
                    this.resetinput.nativeElement.click();
                    this.forgetPassword();
                  }
                  else {
                    this.isForgetPassword = false;
                    this.submitted = false;
                  }
                });
              }
              else if (data['table'][0]['result'] == 'contactAdmin') {
                setTimeout(() => {
                  this.cdr.markForCheck();
                  this.loading = false;
                  //this.toastr.error(this.labelMessages.login_failedcontact.message, this.labelMessages.login_failedcontact.title);
                  this.commonService.showModalValidate(this.labelMessages.login_failedcontact.message, '', this.messageLabel.static_messages.error, this.labelMessages.login_failedcontact.title);
                }, 500);
              }
              else {
                this.commonService.ogLog('Login failed');
                setTimeout(() => {
                  this.cdr.markForCheck();
                  this.loading = false;
                  //this.toastr.error(this.labelMessages.login_failed.message, this.labelMessages.login_failed.title);
                  this.commonService.showModalValidate(this.labelMessages.login_failed.message, '', this.messageLabel.static_messages.error, this.labelMessages.login_failed.title);
                }, 500);



              }
            }
            if (isPresent(data['table'][0].gstibo_screenview_mode) && data['table'][0].gstibo_screenview_mode == "Full Screen") {
              this.fullScreenService.open();
            }
          } else {
            this.commonService.ogLog('Login failed');
            setTimeout(() => {
              this.cdr.markForCheck();
              this.loading = false;
              //this.toastr.error(this.labelMessages.login_failed.message, this.labelMessages.login_failed.title);
              this.commonService.showModalValidate(this.labelMessages.login_failed.message, '', this.messageLabel.static_messages.error, this.labelMessages.login_failed.title);
            }, 500);



          }
        }
          , error => {
            console.log('Loginerror : ', error);
            setTimeout(() => {
              this.cdr.markForCheck();
              this.loading = false;
              // this.toastr.warning(this.labelMessages.internet_error.title);
              this.commonService.showModalValidate(this.labelMessages.internet_error.title, '', this.messageLabel.static_messages.warning, this.labelMessages.internet_error.title);
            }, 500);
          });
      } else {
        this.loading = false;
        if (isBlank(this.loginForm.value.email)) {
          this.commonService.showModalValidate(this.labelMessages.login_input.email, '', this.messageLabel.static_messages.warning, this.labelMessages.login_input.email);
        } else if (isBlank(this.loginForm.value.password)) {
          this.commonService.showModalValidate(this.labelMessages.login_input.password, '', this.messageLabel.static_messages.warning, this.labelMessages.login_input.password);
        } else if (isBlank(this.loginForm.value.recaptcha)) {
          this.commonService.showModalValidate(this.labelMessages.login_input.recaptcha, '', this.messageLabel.static_messages.warning, this.labelMessages.login_input.recaptcha);
        }

      }
    }
  }
  selectCountryForPhone(phoneData: any) {
    const customerid = this.commonService.getUserCredentials(KEYS.credential_customer_id);
    this.commonService.getCountryForPhone(customerid).subscribe(data => {
      if (isData(phoneData)) {
        sessionStorage.setItem(KEYS.countryForPhone, phoneData.gstibo_phone_country.toString());
      }
    });
  }
  selectcustomer_logo(logo_customer: any) {
    let logo_selected = isPresent(logo_customer) ? `${environment.appUrl}${logo_customer}` : '';
    sessionStorage.setItem(KEYS.logo_customer, logo_selected);
  }

  // resetpassword() {
  //   const config: ModalOptions = { class: KEYS.modalConfigClassMD, backdrop: "static", animated: true, }
  //   this.bsModalRef = this.modalService.show(ResetPasswordComponent, config);
  //   this.bsModalRef.content.data = {
  //     title: this.labelForgotPassword.title,
  //     btnConfirm: this.labelForgotPassword.btnConfirm,
  //     btnCancel: this.labelForgotPassword.btnCancel
  //   }
  //   // this.bsModalRef.content.formSubmitEvent.subscribe(resForm => {
  //   // });

  // }
  forgetPassword() {
    this.isForgetPassword = true;
    this.submitted = false;
  }
  backToLogin() {
    this.isForgetPassword = false;
    this.submitted = false;
  }
  validateUsername() {

    this.commonService.ValidateUsername(this.resetPasswordForm.value.username)
      .subscribe((data: any) => {
        if (isData(data)) {
          const retval = data['table'][0].retval;
          const first_name = data['table'][0].first_name;
          if (retval == 2) {
            this.resetPasswordForm.patchValue({
              username: ''
            });
            // this.toastr.warning(this.labelMessages.forgot_Password_input.usernamenotexists);
            this.commonService.showModalValidate(this.labelMessages.forgot_Password_input.usernamenotexists, '', this.messageLabel.static_messages.warning, this.labelMessages.forgot_Password_input.usernamenotexists);
          } else {
            this.onNext(first_name);
          }
        } else {
          this.onNext('');
        }
      }, error => {
        console.log('resetpassworderror : ', error);
        //this.toastr.warning(this.labelMessages.internet_error.title);
        this.commonService.showModalValidate(this.labelMessages.internet_error.title, '', this.messageLabel.static_messages.warning, this.labelMessages.internet_error.title);
      });
  }
  onNext(first_name: any) {

    this.submitted = true;
    this.commonService.ogLog('res11', this.resetPasswordForm.invalid)
    this.commonService.ogLog('res2', this.resetPasswordForm.value.username)
    // if (this.resetPasswordForm.invalid) {
    //   this.toastr.warning("Please fill up mandatory field.");
    //   return;
    // }
    if (this.resetPasswordForm.value.username == "") {
      this.commonService.ogLog('res3', this.resetPasswordForm.value.username)
      return;
    }
    let token = this.commonService.GetUrlToken(this.resetPasswordForm.value.username, environment.appUrl + 'resetPassword', first_name)
      .subscribe((response: any) => {
        this.commonService.ogLog('res4', response)
        if (response['error'] != '' || response['error'] != null) {
          this.commonService.ogLog("Response:", response);
          if (response['error'] != '' && response['error'] != null) {
            // this.toastr.error(response['error']);
            this.commonService.showModalValidate(response['error'], '', this.messageLabel.static_messages.error, response['error']);
          }
          else if (response['message'] != '') {
            let email = response['email'];
            let token = response['token'];
            let url = response['url'];
            let root = environment.appUrl + 'resetPassword';
            url = root + '?username=' + email + '&token=' + token;
            this.commonService.ogLog("Url:", url);
            // this.toastr.success(response['message'], '', { timeOut: 2000 });
            this.commonService.showModalValidate(response['message'], '', this.messageLabel.static_messages.info, response['message']);
            this.resetPasswordForm.patchValue({
              username: ''
            });
            this.submitted = false;
            // this.modalRef.hide(); 
            this.isForgetPassword = false;

          }
          if (response['warning'] != '' && response['warning'] != null) {
            this.commonService.ogLog("Warning:", response['warning']);
          }
          //Due to security reasons, sending mail is done in API.

          /*
          let emailbody='<a href='+url+'>Click here to reset password.. </a>';
          console.log("Email Body:",emailbody);
          let fromaddre='emailtestbo@gmail.com';
          let subject="Reset Password";
          this.commonService.sendEmail(fromaddre,subject,email,emailbody,false,'','',email,'').subscribe((data)=>{
            console.log("Email Response:",data);
          });
          */
        }
        else {
          (error: any) => {
            console.log('Token Generation error:', error);
          }
        }

      }, error => {
        console.log('resetpassworderror : ', error);
        // this.toastr.warning(this.labelMessages.internet_error.title);
        this.commonService.showModalValidate(this.labelMessages.internet_error.title, '', this.messageLabel.static_messages.warning, this.labelMessages.internet_error.title);
      });
  }
  selectCheckBox(targetType: CheckBoxType) {
    this.loginType = targetType.toString();
    if (this.currentlyChecked === targetType) {

      // this.loadCatlog(2);
      this.currentlyChecked = CheckBoxType.NONE;
      return;
    }
    this.currentlyChecked = targetType;
    // this.loadCatlog(targetType);

  }

  get f() { return this.resetPasswordForm.controls; }

  loadLanguageText(languageData: any) {
    if (!isNullOrUndefined(languageData)) {
      sessionStorage.setItem(KEYS.allLanguagesText, JSON.stringify(languageData));
    }
  }
  setControlRights() {
    this.commonService.getPageDetails_static_Dyn('Requirements Checklist', 461).subscribe((dat: any) => {
      if (isPresent(dat['table'])) {
        let pageId = dat['table'][0].gstibo_page_id;
        this.commonService.moreControlLoadStatic_in_Dynamic(pageId, this.commonService.getUserCredentials(KEYS.credential_account_id), 1).subscribe((data: any) => {
          if (isPresent(data['table'])) {//&& !isPresent(this.controllistArray) 
            sessionStorage.removeItem('rolesControlsrights');
            sessionStorage.setItem('rolesControlsrights', JSON.stringify(data['table']));
          }
        });
      }
    });
  }
  setControlRightsSourcing() {
    this.commonService.getPageDetails_static_Dyn('Requirements Checklist', 330).subscribe((dat: any) => {
      if (isPresent(dat['table'])) {
        let pageId = dat['table'][0].gstibo_page_id;
        this.commonService.moreControlLoadStatic_in_Dynamic(pageId, this.commonService.getUserCredentials(KEYS.credential_account_id), 1).subscribe((data: any) => {
          if (isPresent(data['table'])) {//&& !isPresent(this.controllistArray) 
            sessionStorage.removeItem('rolesControlsrightssourcing');
            sessionStorage.setItem('rolesControlsrightssourcing', JSON.stringify(data['table']));
          }
        });
      }
    });
  }
  setControlRightsHRReview() {
    this.commonService.getPageDetails_static_Dyn('Requirements Checklist', 337).subscribe((dat: any) => {
      if (isPresent(dat['table'])) {
        let page_Id = dat['table'][0].gstibo_page_id;
        this.commonService.moreControlLoadStatic_in_Dynamic(page_Id, this.commonService.getUserCredentials(KEYS.credential_account_id), 1).subscribe((data: any) => {
          if (isPresent(data['table'])) {//&& !isPresent(this.controllistArray) 
            sessionStorage.removeItem('rolesControlsrightshrreview');
            sessionStorage.setItem('rolesControlsrightshrreview', JSON.stringify(data['table']));
          }
        });
      }
    });
  }
   runDailyManageUserContactSync() {

    const now = new Date();
    const today = `${now.getFullYear()}-` + `${String(now.getMonth() + 1).padStart(2, '0')}-` + `${String(now.getDate()).padStart(2, '0')}`;
    const lastSync = localStorage.getItem('manageUserContactLastSync');
    if (lastSync === today) {
      return;
    }
    this.commonService.syncManageUserContacts().subscribe({
      next: () => {
        localStorage.setItem('manageUserContactLastSync', today);
      },
      error: (error: any) => {
        console.error('Daily Manage User Contact Sync Failed', error);
      }
    });

  }
  setControlRightsManagementApproval() {
    this.commonService.getPageDetails_static_Dyn('Requirements Checklist', 401).subscribe((dat: any) => {
      if (isPresent(dat['table'])) {
        let page_Id = dat['table'][0].gstibo_page_id;
        this.commonService.moreControlLoadStatic_in_Dynamic(page_Id, this.commonService.getUserCredentials(KEYS.credential_account_id), 1).subscribe((data: any) => {
          if (isPresent(data['table'])) {//&& !isPresent(this.controllistArray) 
            sessionStorage.removeItem('rolesControlsrightsmgtapproval');
            sessionStorage.setItem('rolesControlsrightsmgtapproval', JSON.stringify(data['table']));
          }
        });
      }
    });
  }
  getIpAddress() {
    let path2 = 'https://ipinfo.io/json';
    this.http.get(path2).subscribe((ds: any) => {
      this.commonService.ogLog('ipadd', ds);
      this.ipAddress = ds['ip'];
      this.commonService.ogLog('ipadd', this.ipAddress);

    });
  }

  private navigateUserToDefaultList() {
    this.commonService.getMasterData(this.commonService.getUserCredentials(KEYS.credential_account_id), 1, 1).subscribe((data: any) => {
      let menudata;
      let isDashboard = false;
      if (isPresent(data['menu']) && isPresent((data['menu'])['table'])) {
        menudata = (data['menu'])['table'];
        this.commonService.ogLog('menudata', menudata);

        sessionStorage.setItem(KEYS.userMenuList, JSON.stringify(menudata));
        this.commonService.loadMenuForUser(this.commonService.getUserCredentials(KEYS.credential_account_id)).subscribe((fullmenuDt: any) => {
          sessionStorage.setItem(KEYS.FullmenuData, JSON.stringify(fullmenuDt));
          this.commonService.loadDefaultUserMenuSettings(this.commonService.getUserCredentials(KEYS.credential_account_id)).subscribe((defaultInfo: any) => {
            let parentmenu = '';
            let pageDetails = {
              pageId: 0,
              pageName: '',
              parentMenuId: 0,
              menuId: 0,
              isAddMode: false,
              withChildInnerPage: 0,
              withChildMenues: 0
            }
            const jusaDefaultMenuIds = defaultInfo['table'][0];
            const contactMenu = fullmenuDt['table'].find((menu: any) => menu.gstibo_menu_name == "Contact Details" && menu.viewright == "true");
            if (isPresent(contactMenu)) {
              pageDetails = {
                pageId: jusaDefaultMenuIds.gstibo_contacts_menu_pageId,
                pageName: 'Contact Details',
                parentMenuId: jusaDefaultMenuIds.gstibo_contacts_parent_menu_id,
                menuId: jusaDefaultMenuIds.gstibo_contacts_menu_id,
                isAddMode: false,
                withChildInnerPage: 0,
                withChildMenues: 0
              };
              parentmenu = 'Contacts';
            } else {
              // const recruitmentMenua = fullmenuDt['table'].filter((menu: any) => menu.moduleid == 181);
              const recruitmentMenu = fullmenuDt['table'].find((menu: any) => menu.gstibo_menu_name == "Resource Request"
                && menu.gstibo_app_description == "Requisition" && menu.viewright == "true");
              if (isPresent(recruitmentMenu)) {
                pageDetails = {
                  pageId: jusaDefaultMenuIds.gstibo_requisition_menu_pageId,
                  pageName: 'Requisition',
                  parentMenuId: jusaDefaultMenuIds.gstibo_requisition_parent_menu_id,
                  menuId: jusaDefaultMenuIds.gstibo_requisition_menu_id,
                  isAddMode: false,
                  withChildInnerPage: 0,
                  withChildMenues: 0
                }
                parentmenu = 'Recruitment';
              } else {
                const opportunityMenu = fullmenuDt['table'].find((menu: any) => menu.gstibo_menu_name == "Opportunity" && menu.viewright == "true");
                if (isPresent(opportunityMenu)) {
                  pageDetails = {
                    pageId: jusaDefaultMenuIds.gstibo_opportunity_menu_pageId,
                    pageName: 'Opportunity',
                    parentMenuId: jusaDefaultMenuIds.gstibo_opportunity_parent_menu_id,
                    menuId: jusaDefaultMenuIds.gstibo_opportunity_menu_id,
                    isAddMode: false,
                    withChildInnerPage: 0,
                    withChildMenues: 0
                  }
                  parentmenu = 'Procurement';
                }
                else {
                  this.router.navigate([this.routePath.dashboardUser], { queryParams: { menuid: environment.dashboardId } });
                  isDashboard = true;
                }
              }
            }
            if (!isDashboard) {
              sessionStorage.setItem(KEYS.mainPageDetails, JSON.stringify(pageDetails));
              this.commonService.setParentMenuName(parentmenu);
              sessionStorage.setItem('moduleName', parentmenu);
              sessionStorage.setItem("acivemenuId", pageDetails.parentMenuId.toString());
              this.router.navigate([RoutePath.userPageLayout, pageDetails.pageName], { queryParams: { pageDetails: JSON.stringify(pageDetails) } });
            }
          });
        });
      }
    });
  }
  setMultiCatgoryvalue() {
    this.commonService.getmultiplecategoryvalue().subscribe((category: any) => {
      let data = isPresent(category) && isPresent(category['table']) ? category['table'] : [];
      sessionStorage.setItem(KEYS.MultipleTextboxCategory, JSON.stringify(data));
    });
    this.commonService.getSettingTblData().subscribe((data: any) => {
      let settingsdate = isPresent(data) && isPresent(data['table']) ? data['table'] : [];
      const compensationlimit = settingsdate.gstibo_compensation_limit ? settingsdate.gstibo_compensation_limit : 1000000;
      sessionStorage.setItem(KEYS.compensationlimit, JSON.stringify(compensationlimit));
    });
  }
}

